import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SCENARIOS = [
  {
    id: 'travel', label: '无证件出行', icon: 'ri-plane-line', color: '#00d4ff',
    title: '2035年：无证件环球旅行',
    desc: '你的生物特征就是你的护照。扫描虹膜或掌纹，即可完成全球任何国家的入境手续，全程不超过3秒。',
    image: 'https://public.readdy.ai/ai/img_res/d45729dce6011c5c545da6cd29f1fb1a.jpg',
    story: '2035年，李明从上海出发前往巴黎，全程没有携带任何证件。在浦东机场，他只需在生物识别门前停留2秒，系统自动完成护照验证、安检和登机手续。抵达戴高乐机场，同样的流程让他在30秒内完成入境。',
    steps: ['虹膜扫描 (0.5秒)', '量子加密验证 (1秒)', '全球数据库比对 (0.5秒)', '自动放行 (1秒)'],
    stats: [{ label: '验证时间', value: '3秒' }, { label: '准确率', value: '99.999%' }, { label: '覆盖国家', value: '195个' }, { label: '年使用次数', value: '500亿次' }],
  },
  {
    id: 'payment', label: '无货币交易', icon: 'ri-hand-coin-line', color: '#00ff88',
    title: '2037年：扫脸即付款',
    desc: '货币、银行卡、手机都不再需要。你的面部、指纹或掌纹就是你的钱包，所有交易在量子加密网络中即时完成。',
    image: 'https://readdy.ai/api/search-image?query=face%20payment%20biometric%20transaction%20futuristic%20store%20cashless%20society%20digital%20payment%20scan%20face%202037&width=800&height=450&seq=da2&orientation=landscape',
    story: '2037年，王芳在超市购物，结账时只需对着收银台的摄像头微笑，系统自动识别她的身份，从她的数字资产账户中扣除相应金额，整个过程不到1秒。她甚至不需要掏出手机。',
    steps: ['面部识别 (0.3秒)', '身份确认 (0.2秒)', '资产验证 (0.3秒)', '交易完成 (0.2秒)'],
    stats: [{ label: '交易时间', value: '<1秒' }, { label: '欺诈率', value: '0.0001%' }, { label: '全球用户', value: '80亿' }, { label: '日交易量', value: '1000亿次' }],
  },
  {
    id: 'assets', label: '万物数字化', icon: 'ri-database-2-line', color: '#8800ff',
    title: '2038年：所有资产上链',
    desc: '房产、车辆、艺术品、学历、健康记录……所有有价值的东西都有对应的数字资产凭证，存储在量子加密区块链上，永不丢失，永不可篡改。',
    image: 'https://readdy.ai/api/search-image?query=digital%20assets%20blockchain%20everything%20tokenized%20NFT%20real%20estate%20car%20art%20certificate%20digital%20ownership%20futuristic&width=800&height=450&seq=da3&orientation=landscape',
    story: '2038年，张伟购买了一套房子，整个过程在元宇宙中完成。他在虚拟现实中参观了房子，用掌纹签署了合同，房产证作为NFT即时转入他的数字钱包。整个交易过程不需要任何中介，费用降低了99%。',
    steps: ['资产数字化登记', '区块链确权', '智能合约执行', '数字凭证发放'],
    stats: [{ label: '数字化资产', value: '$500万亿', }, { label: '交易成本降低', value: '99%' }, { label: '确权时间', value: '即时' }, { label: '纠纷减少', value: '95%' }],
  },
  {
    id: 'medical', label: '医疗无纸化', icon: 'ri-heart-pulse-line', color: '#ff6600',
    title: '2036年：全球统一健康档案',
    desc: '你的完整医疗记录存储在量子加密云端，全球任何医院都可以在你授权后即时访问。不再需要携带病历本，不再需要重复检查。',
    image: 'https://readdy.ai/api/search-image?query=digital%20health%20record%20medical%20AI%20doctor%20holographic%20patient%20data%20futuristic%20hospital%20technology%202036&width=800&height=450&seq=da4&orientation=landscape',
    story: '2036年，陈华在旅行途中突发疾病，被送往当地医院。医生通过虹膜扫描获取了他的完整医疗记录，包括过敏史、用药记录和基因数据，在5分钟内制定了精准的治疗方案，避免了可能的药物过敏反应。',
    steps: ['生物识别授权', '全球档案调取', 'AI辅助诊断', '精准治疗方案'],
    stats: [{ label: '误诊率降低', value: '90%' }, { label: '治疗效率提升', value: '300%' }, { label: '医疗成本降低', value: '60%' }, { label: '覆盖人口', value: '80亿' }],
  },
  {
    id: 'education', label: '学历全球认证', icon: 'ri-graduation-cap-line', color: '#ff00ff',
    title: '2039年：技能即通行证',
    desc: '学历证书、职业资格、技能认证全部上链，全球雇主即时验证。不再有假文凭，不再有学历歧视，能力才是唯一标准。',
    image: 'https://readdy.ai/api/search-image?query=digital%20diploma%20blockchain%20education%20credential%20verification%20global%20recognition%20futuristic%20technology&width=800&height=450&seq=da5&orientation=landscape',
    story: '2039年，来自肯尼亚的程序员Amara通过元宇宙学习平台获得了量子计算认证，这个认证被全球500强企业即时认可。她在家中通过VR面试，成功加入了一家硅谷科技公司，完全远程工作。',
    steps: ['技能评估认证', '区块链存证', '全球雇主验证', '即时就业匹配'],
    stats: [{ label: '假文凭减少', value: '100%' }, { label: '跨国就业增加', value: '500%' }, { label: '技能认证数量', value: '10万种' }, { label: '就业匹配效率', value: '+400%' }],
  },
  {
    id: 'border', label: '无护照出行', icon: 'ri-map-pin-line', color: '#ffaa00',
    title: '2040年：地球公民时代',
    desc: '随着全球数字身份系统的完善，护照的概念逐渐消失。每个人都是地球公民，可以自由移动到任何地方，只需要你的生物特征。',
    image: 'https://readdy.ai/api/search-image?query=global%20citizen%20earth%20passport%20free%20movement%20biometric%20border%20control%20futuristic%20world%20unity%202040&width=800&height=450&seq=da6&orientation=landscape',
    story: '2040年，联合国宣布实施"地球公民计划"，195个国家同意互认生物特征身份。从此，人类历史上第一次实现了真正的自由流动，国界不再是人员流动的障碍，只是行政管理的边界。',
    steps: ['全球身份注册', '生物特征绑定', '量子加密保护', '全球互认协议'],
    stats: [{ label: '签证申请减少', value: '100%' }, { label: '边境等待时间', value: '-95%' }, { label: '非法移民减少', value: '80%' }, { label: '全球流动人口', value: '20亿' }],
  },
];

const TIMELINE = [
  { year: '2025', event: '全球数字身份标准制定', color: '#00d4ff' },
  { year: '2028', event: '50个国家实现生物识别入境', color: '#00ff88' },
  { year: '2030', event: '全球数字资产交易所建立', color: '#8800ff' },
  { year: '2033', event: '无货币支付覆盖全球80%人口', color: '#ff6600' },
  { year: '2036', event: '全球统一医疗档案系统上线', color: '#ff00ff' },
  { year: '2040', event: '地球公民计划全面实施', color: '#ffaa00' },
];

export default function DigitalAssetsPage() {
  const navigate = useNavigate();
  const [activeScenario, setActiveScenario] = useState(SCENARIOS[0]);
  const [scanActive, setScanActive] = useState(false);
  const [scanComplete, setScanComplete] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'META66数字资产 | 无证件时代·生物识别·万物数字化·无货币交易';

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://meta66.cn';

    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        '@id': `${siteUrl}/digital-assets#webpage`,
        url: `${siteUrl}/digital-assets`,
        name: 'META66数字资产 | 无证件时代·生物识别·万物数字化·无货币交易',
        description: '探索META66数字资产未来：无证件环球旅行、扫脸即付款、万物数字化上链、医疗无纸化、学历全球认证与地球公民时代，感受生物识别与区块链重塑的数字文明。',
        inLanguage: 'zh-CN',
        dateModified: '2026-04-04',
        isPartOf: { '@id': `${siteUrl}/#website` },
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: '数字资产', item: `${siteUrl}/digital-assets` },
          ],
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: '无证件时代：生物识别与区块链重塑数字文明',
        url: `${siteUrl}/digital-assets`,
        description: '2035-2040年，生物识别技术与区块链将彻底改变人类的出行、支付、资产管理和身份认证方式，开启真正的无证件、无货币、无边界时代。',
        author: { '@type': 'Organization', name: 'META66' },
        publisher: { '@type': 'Organization', name: 'META66', url: siteUrl },
        dateModified: '2026-04-04',
        inLanguage: 'zh-CN',
        keywords: '数字资产,生物识别,无证件,无货币,区块链,数字身份,万物数字化',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '未来无证件出行如何实现？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '通过虹膜扫描或掌纹识别，系统在3秒内完成护照验证、安检和登机手续，准确率达99.999%，覆盖195个国家，年使用次数达500亿次。',
            },
          },
          {
            '@type': 'Question',
            name: '扫脸支付安全吗？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '扫脸支付基于量子加密网络，交易时间不到1秒，欺诈率仅0.0001%，全球用户达80亿，日交易量超1000亿次，安全性远超传统支付方式。',
            },
          },
        ],
      },
    ];

    const existingScript = document.getElementById('schema-digitalassets-jsonld');
    if (existingScript) existingScript.remove();

    const script = document.createElement('script');
    script.id = 'schema-digitalassets-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemas);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('schema-digitalassets-jsonld');
      if (s) s.remove();
    };
  }, []);

  const handleScan = () => {
    setScanActive(true);
    setScanComplete(false);
    setTimeout(() => {
      setScanActive(false);
      setScanComplete(true);
    }, 2000);
  };

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', 'PingFang SC', sans-serif" }}>
      {/* Header */}
      <div className="sticky top-0 z-50 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-left-line" />
            <span className="text-sm">返回首页</span>
          </button>
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #00d4ff, #00ff88)' }}>
              <i className="ri-fingerprint-line text-white text-sm" />
            </div>
            <span className="font-bold text-gray-900">数字资产 · 无证件时代</span>
          </div>
          <div className="text-sm text-gray-400">META66 · 数字未来</div>
        </div>
      </div>

      {/* Hero */}
      <div className="relative h-80 overflow-hidden">
        <img src={activeScenario.image} alt="数字资产" className="w-full h-full object-cover object-top transition-all duration-700" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" />
        <div className="absolute inset-0 flex items-center px-16">
          <div>
            <h1 className="text-5xl font-black text-white mb-3" style={{ fontFamily: "'Orbitron', monospace" }}>DIGITAL FUTURE</h1>
            <p className="text-gray-300 text-lg max-w-xl">无证件、无货币、无边界 · 数字身份即一切</p>
          </div>
        </div>
      </div>

      {/* Scenario Tabs */}
      <div className="border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex gap-1 overflow-x-auto py-2">
            {SCENARIOS.map(s => (
              <button key={s.id} onClick={() => setActiveScenario(s)}
                className="flex items-center gap-2 px-4 py-3 rounded-xl text-sm font-medium transition-all whitespace-nowrap cursor-pointer flex-shrink-0"
                style={{
                  background: activeScenario.id === s.id ? `${s.color}15` : 'transparent',
                  color: activeScenario.id === s.id ? s.color : '#888',
                  border: `1px solid ${activeScenario.id === s.id ? s.color : 'transparent'}`,
                }}>
                <i className={s.icon} />
                {s.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Scenario Detail */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          <div className="lg:col-span-2">
            <h2 className="text-3xl font-black text-gray-900 mb-3">{activeScenario.title}</h2>
            <p className="text-gray-600 leading-relaxed mb-6">{activeScenario.desc}</p>

            <div className="p-6 rounded-2xl mb-6" style={{ background: `${activeScenario.color}08`, border: `1px solid ${activeScenario.color}20` }}>
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-book-open-line" style={{ color: activeScenario.color }} />
                <span className="font-bold text-gray-900">真实场景故事</span>
              </div>
              <p className="text-gray-700 leading-relaxed italic">{activeScenario.story}</p>
            </div>

            <div>
              <h3 className="font-bold text-gray-900 mb-4">流程步骤</h3>
              <div className="flex flex-wrap gap-3">
                {activeScenario.steps.map((step, i) => (
                  <div key={step} className="flex items-center gap-2 px-4 py-2 rounded-full"
                    style={{ background: `${activeScenario.color}10`, border: `1px solid ${activeScenario.color}30` }}>
                    <span className="w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold text-white"
                      style={{ background: activeScenario.color }}>
                      {i + 1}
                    </span>
                    <span className="text-sm text-gray-700">{step}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div>
            {/* Biometric Demo */}
            <div className="p-6 rounded-2xl border border-gray-100 mb-4 text-center">
              <h3 className="font-bold text-gray-900 mb-4">生物识别演示</h3>
              <div className="relative w-32 h-32 mx-auto mb-4 cursor-pointer" onClick={handleScan}>
                <div className="w-full h-full rounded-full flex items-center justify-center"
                  style={{
                    background: scanComplete ? '#00ff8820' : scanActive ? `${activeScenario.color}20` : '#f5f5f5',
                    border: `3px solid ${scanComplete ? '#00ff88' : scanActive ? activeScenario.color : '#ddd'}`,
                    transition: 'all 0.3s',
                  }}>
                  <i className={`ri-fingerprint-line text-5xl ${scanActive ? 'animate-pulse' : ''}`}
                    style={{ color: scanComplete ? '#00ff88' : scanActive ? activeScenario.color : '#ccc' }} />
                </div>
                {scanActive && (
                  <div className="absolute inset-0 rounded-full border-4 animate-ping"
                    style={{ borderColor: activeScenario.color, opacity: 0.3 }} />
                )}
              </div>
              {scanComplete ? (
                <div className="text-green-500 font-bold flex items-center justify-center gap-2">
                  <i className="ri-checkbox-circle-line" />
                  验证成功！
                </div>
              ) : (
                <p className="text-gray-400 text-sm">{scanActive ? '正在验证...' : '点击指纹图标体验验证'}</p>
              )}
            </div>

            {/* Stats */}
            <div className="p-5 rounded-2xl" style={{ background: `${activeScenario.color}08`, border: `1px solid ${activeScenario.color}20` }}>
              <h3 className="font-bold text-gray-900 mb-4">关键数据</h3>
              {activeScenario.stats.map(stat => (
                <div key={stat.label} className="flex justify-between items-center py-2 border-b border-gray-100 last:border-0">
                  <span className="text-gray-500 text-sm">{stat.label}</span>
                  <span className="font-black" style={{ color: activeScenario.color }}>{stat.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className="mb-16">
          <h2 className="text-3xl font-black text-gray-900 mb-8 text-center">数字化进程时间线</h2>
          <div className="relative overflow-x-auto">
            <div className="flex gap-0 min-w-max mx-auto">
              {TIMELINE.map((item, i) => (
                <div key={item.year} className="flex flex-col items-center" style={{ width: '180px' }}>
                  <div className="w-4 h-4 rounded-full border-4 border-white z-10" style={{ background: item.color }} />
                  {i < TIMELINE.length - 1 && (
                    <div className="absolute" style={{ width: '180px', height: '2px', background: '#eee', top: '8px', left: '90px' }} />
                  )}
                  <div className="mt-4 text-center px-2">
                    <div className="font-black text-xl mb-1" style={{ color: item.color }}>{item.year}</div>
                    <p className="text-gray-600 text-xs leading-relaxed">{item.event}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* All Scenarios */}
        <div>
          <h2 className="text-3xl font-black text-gray-900 mb-8 text-center">六大数字化场景</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {SCENARIOS.map(s => (
              <button key={s.id} onClick={() => setActiveScenario(s)}
                className="p-4 rounded-2xl text-center transition-all cursor-pointer hover:-translate-y-1"
                style={{
                  background: activeScenario.id === s.id ? `${s.color}15` : '#f9f9f9',
                  border: `1px solid ${activeScenario.id === s.id ? s.color : '#eee'}`,
                }}>
                <div className="w-10 h-10 rounded-xl flex items-center justify-center mx-auto mb-2" style={{ background: `${s.color}20` }}>
                  <i className={`${s.icon} text-lg`} style={{ color: s.color }} />
                </div>
                <div className="font-medium text-gray-900 text-xs">{s.label}</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
